import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PlatformLocation } from "@angular/common";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
    currBaseURL: any;

  constructor(
    private route: Router,
    private platformLocation: PlatformLocation
  ) {

    this.currBaseURL = (this.platformLocation as any).location.origin;

   }

  ngOnInit(): void {
  }

  goToLanding(){
    this.route.navigate(['landing']);
    // this.route.navigateByUrl("/landing")
    // this.route.navigate(['landing'])
    // .then(() => {
    //     window.location.reload();
    // });

    // window.location.href = this.currBaseURL + '/'

    // alert(this.currBaseURL)

  }

  mobileMenuBarTransform() {
    var barContainer = document.getElementById("barContainer");
    barContainer.classList.toggle("change");
  }

  goToAboutUs(){
    this.route.navigate(['about-us']);
  }

  goToTracking(choice){
    if(choice=="track"){
      sessionStorage.setItem("subComponent", "track");
    }
    else{
      sessionStorage.setItem("subComponent", "proof");
    }
    this.route.navigate(['tracking']);
  }

  goToFindABranch(){
    this.route.navigate(['find-a-branch']);
  }

  goToContactUs(){
    this.route.navigate(['contact-us']);
  }

  goToHome(){
    this.route.navigate(['home']);
  }

  goToPortal(){
    window.open('https://www.lineclearexpressonline.com/#/auth/login');
}

 
}